module.exports = __webpack_public_path__ + "img/about-illustration@2x.62e694b1.png";